import React, {useEffect, useEffectEvent, useImperativeHandle, useState} from 'react';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import projectUtils from "../../../../../utils/project-utils.js";
import {toast} from "react-toastify";
import formBuilderService from "../../../../../services/web/form-builder-service.js";
import FormRender from "../../components/form-render.jsx";
import ModalAttaches from "../../../../../components/modal/modal-attaches.jsx";

const MySwal = withReactContent(Swal);

const FormFill = ({submitRef, handleModule, templates, templateId, externalId, object, setIsLoading}) => {
    const form = templates?.find(item => item.id === templateId)

    const [state, setState] = useState({})
    const [modalAttaches, setModalAttaches] = useState({open: false, file: undefined, structureId: undefined})

    useEffect(() => {
        if (!form) return

        setState(() => {
            const newPrev = {}
            form.structure.forEach((item) => {
                if (item.type !== "subtitle" && item.type !== "title") {
                    newPrev[item.id] = item?.referenceId ? searchValue(item.referenceId) : null;
                }
            })

            return newPrev
        })

    }, [form])


    const searchValue = useEffectEvent((referenceId) => {
        const keys = referenceId.split('.');
        let current = object;

        for (const key of keys) {
            if (current === undefined || current === null) return undefined;

            if (Array.isArray(current)) {
                if (current.length === 0) return undefined;

                current = current[0];
                if (current === undefined || current === null) return undefined;
            }

            if (current[key] === undefined) return undefined;

            current = current[key];
        }

        return current;
    })

    const openModalAttach = (e, file, id) => {
        e.preventDefault()

        setModalAttaches({open: true, file, structureId: id})
    }

    const closeModalAttaches = () => {
        setModalAttaches({open: false, file: undefined, structureId: undefined})
    }

    const removeFile = (file) => {
        setState(prev => ({...prev, [file.targetId]: null}))
        closeModalAttaches()
    }

    useImperativeHandle(submitRef, () => ({
        submit: () => {
            projectUtils.swalMessage(
                "warning",
                "Atenção!",
                "Após salvar, não será possível editar este formulário.\n Deseja continuar?",
                "Sim",
                true,
                "Não",
                ({isConfirmed}) => {
                    if (!isConfirmed) return;

                    setTimeout(() => {
                        const payload = {...state}

                        form.structure.filter(structure => structure.type === "agentSignature")
                            .forEach(({id}) => payload[id] = payload[id]?.attachId || null)

                        const formData = new FormData()
                        formData.append("formTemplateId", templateId)
                        formData.append("payload", JSON.stringify(payload))
                        formData.append("externalId", externalId || null)

                        const fileEl = form.structure.filter(structure => structure.type === "file")
                        fileEl.forEach(({id}) => {
                            const file = payload[id]

                            if (file) formData.append("files", file, id)
                            delete payload[id]
                        })

                        if (setIsLoading) setIsLoading(true)

                        formBuilderService.submission(formData)
                            .then(() => {
                                toast.success("Salvo com sucesso")
                                handleModule("submissions", templateId)
                            })
                            .catch((error) => {
                                console.error(error)

                                let message = "Não foi possível salvar."
                                const errorMap = error.response.data;
                                if (!!errorMap && Object.keys(errorMap).length) {
                                    const key = Object.keys(errorMap)[0]
                                    const find = form?.structure.find(s => s.id === key);

                                    if (find) message = errorI18n(errorMap[key], find.label);
                                }

                                projectUtils.swalErrorMessage('', message, 'Ok')
                            })
                            .finally(() => { if (setIsLoading) setIsLoading(false) })
                    }, 100)
                }
            )
        }
    }));

    const errorI18n = (error, value = "") => {
        const i18n = {
            "is.required": "O campo \"%s\" é obrigatório."
        }

        return i18n[error].replace("%s", value);
    }

    return (
        <>
            <form id="form-created" className="flex flex-col gap-3 p-4 overflow-auto h-[calc(100vh-220px)]">
                <FormRender structure={form?.structure} state={state} setState={setState} openModalAttach={openModalAttach}/>
            </form>

            <ModalAttaches
                open={modalAttaches.open}
                setOpen={closeModalAttaches}
                file={modalAttaches.file}
                removeFile={removeFile}
            />
        </>
    );
};

export default FormFill;